import { Controller } from "@hotwired/stimulus";

// Drives the commission add/edit form: when the incentive program changes,
// repopulate the tier dropdown and seed the bonus amount from the selected
// tier's default. Selecting a tier also resets the amount to its default. The
// amount stays editable so users can override per entry.
export default class extends Controller {
  static targets = ["program", "tier", "amount"];
  static values = { programs: Object };

  programChanged() {
    this.rebuildTiers();
    this.applyTierAmount();
  }

  tierChanged() {
    this.applyTierAmount();
  }

  rebuildTiers() {
    const tiers = this.programsValue[this.programTarget.value] || {};
    const select = this.tierTarget;
    select.innerHTML = "";

    const blank = document.createElement("option");
    blank.value = "";
    blank.textContent = "Select…";
    select.appendChild(blank);

    Object.entries(tiers).forEach(([key, tier]) => {
      const option = document.createElement("option");
      option.value = key;
      option.textContent = tier.label;
      select.appendChild(option);
    });
  }

  applyTierAmount() {
    const tiers = this.programsValue[this.programTarget.value] || {};
    const tier = tiers[this.tierTarget.value];
    if (tier && tier.amount != null) {
      this.amountTarget.value = tier.amount;
    }
  }
}
